import { breakpoints } from "./breakpoints";

export const lightTheme = {
  name: 'light',
  breakpoints,
  colors: {
    background: '#FFFFFF',
    backgroundSecondary: '#FFFFFF',
    main: '#f1f5f9',

    textPrimary: '#21262D',
    textSecondary: '#343A40',
    textMuted: '#8390A2',
    textInverse: '#FFFFFF',

    borderSubtle: '#F1F5F9',
    borderDefault: '#E2E8F0',
    borderStrong: '#CBD5E1',

    action: {
      primary: {
        bg: '#3ECF8E',
        bgHover: '#34B27B',
        bgActive: '#2C9C6A',
        borderHover: '#1F4B37',
        text: '#FAFAFA'
      },
      danger: {
        bg: '#DC2626',
        bgHover: '#B91C1C',
        bgActive: '#991B1B',
        text: '#FFFFFF'
      },
      neutral: {
        bg: '#E2E8F0',
        bgHover: '#CBD5E1',
        bgActive: '#94A3B8',
        text: '#21262D'
      },
      ghost: {
        bg: 'transparent',
        bgHover: '#F1F5F9',
        bgActive: '#E2E8F0',
        text: '#21262D'
      }
    },
  },
  typography: {
    fontFamily: 'Poppins, system-ui, sans-serif',
    
    h1: { fontSize: '2rem', fontWeight: 700, lineHeight: 1.2, color: '#21262D' },
    h2: { fontSize: '1.75rem', fontWeight: 700, lineHeight: 1.3, color: '#21262D' },
    h3: { fontSize: '1.5rem', fontWeight: 600, lineHeight: 1.4, color: '#21262D' },
    h4: { fontSize: '1.25rem', fontWeight: 600, lineHeight: 1.4, color: '#21262D' },
    h5: { fontSize: '1rem', fontWeight: 500, lineHeight: 1.5, color: '#21262D' },
    h6: { fontSize: '0.875rem', fontWeight: 500, lineHeight: 1.5, color: '#21262D' },
    
    p: { fontSize: '1rem', fontWeight: 400, lineHeight: 1.6, color: '#343A40' },
    small: { fontSize: '0.75rem', fontWeight: 400, lineHeight: 1.4, color: '#8390A2' },
  },
}
